import React from "react";
import { Skill, getRequiredPointsForRow, getUsedSkillPoints } from "./SkillData";
import { SkillOption } from "./SkillOption";

import "./SkillRow.scss";
import { SkillLevels } from "./SkillSimulator";

export interface SkillRowProps {
    skillsIDs: number[];
    skills: Skill[];
    levels: SkillLevels;
    selectedSkill: number;
    rowIndex: number;
    onLevelChange?: (id: number, lvl: number) => void;
    onSkillSelected?: (id: number) => void;
    onSkillMasteryAddRequest?: (id: number) => void;
    masteryOpen?: boolean;
}

export class SkillRow extends React.Component<SkillRowProps> {
    // Used to pass temp value to renderSkillOption
    private disabled = false;
    constructor(props: SkillRowProps) {
        super(props);
        this.renderSkillOption = this.renderSkillOption.bind(this);
    }
    renderSkillOption(id: number) {
        const skill = this.props.skills.find(s => s.id == id);
        if (!skill) {
            return `[missing-skill:${id}]`;
        } else {
            return <SkillOption key={id} onSkillSelected={this.props.onSkillSelected} onLevelChange={this.props.onLevelChange}
             levels={this.props.levels} skill={skill} selected={id == this.props.selectedSkill} disabled={this.disabled} 
             masteryOpen={this.props.masteryOpen} onSkillMasteryAddRequest={this.props.onSkillMasteryAddRequest} />
        }
    }
    render(): React.ReactNode {
        const firstHalf = this.props.skillsIDs.slice(0, Math.floor(this.props.skillsIDs.length / 2));
        const secondHalf = this.props.skillsIDs.slice(firstHalf.length);
        const spentPoints = getUsedSkillPoints(this.props.levels);
        const selfRequiredPoints = getRequiredPointsForRow(this.props.rowIndex);
        const disabled = spentPoints < selfRequiredPoints;
        this.disabled = disabled;
        const cl = `skill-simulator-row${disabled ? " disabled" : ""}`;
        return <div className={cl}>
            <div className="skill-simulator-row-inner">
                {firstHalf.map(this.renderSkillOption)}
            </div>
            <div className="skill-simulator-row-inner">
                {secondHalf.map(this.renderSkillOption)}
            </div>
        </div>
    }
}

